;
/*!
 * subitotexto.contestresults.js
 */
SubitoTexto.contestResults = {

	init                : function () {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;

		_this.$finalistsContainer = $( '.finalists-container ' );
		_this.$finalists = _this.$finalistsContainer.find( '.finalist' );
		_this.$finalistsInfo = _this.$finalistsContainer.find( '.finalist' ).find( '.finalist-info' );
		_this.finalistBreakpoint = 641;


		_this.$starContainers = $( '.stars-container' );


		$( ".inline" ).colorbox( { inline: true, width: "80%", height: "80%", opacity: 0.8 } );

		if ( _this.$starContainers.length > 0 ) {
			_this.bindEvents();

			new Fingerprint2( {
				excludeAvailableScreenResolution: true,
				excludeScreenResolution         : true
			} ).get( function ( result, components ) {
				_this.fingerprint = result;
			} );


			_this.cookieVote();

		}

		if ( _this.$finalists.length > 0 ) {
			_this.equalHeights( _this.$finalists );
			_this.bindResize();
		}


	},
	bindEvents          : function () {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;


		_this.$starContainers.on( 'mouseenter.votefinalist', '.vote-star', function ( e ) {

			if ( $( this ).parents( '.finalist' ).hasClass( 'has-voted' ) ) {
				return false;
			}

			var $this = $( this ),
				$container = $this.parents( '.stars-container' ),
				$allStars = $container.find( '.vote-star' ),
				$prevStars = $this.add( $this.prevAll() ),
				$nextStars = $this.nextAll();

			$nextStars.removeClass( 'active' );
			$prevStars.addClass( 'active' );

		} )
			.on( 'mouseleave.votefinalist', function ( e ) {
				if ( $( this ).parents( '.finalist' ).hasClass( 'has-voted' ) ) {
					return false;
				}

				var $this = $( this ),
					$container = $this.parents( '.stars-container' ),
					$allStars = $this.find( '.vote-star' );


				$allStars.removeClass( 'active' );
			} )
			.on( 'click.votefinalist', '.vote-star', function ( e ) {
				e.preventDefault();

				var $this = $( this ),
					$finalistContainer = $this.parents( '.finalist' ),
					$votingContainer = $this.parents( '.stars-container' );

				if ( !$finalistContainer.hasClass( 'has-voted' ) ) {
					_this.voteBegin( $this );
				}
			} );
	},
	bindResize          : function () {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;


		var debounceEqualHeights = PLA.UTILS.debounce( function () {
			_this.equalHeights();
		}, 250 );

		window.addEventListener( 'resize', debounceEqualHeights );
	},
	voteBegin           : function ( $clicked ) {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;

		var clickedVote = $clicked.parents( '.stars-container' ).find( '.vote-star' ).index( $clicked ) + 1,
			$clickedContainer = $clicked.parents( '.finalist' );

		_this.displayConfirmation( $clickedContainer, clickedVote );
		$clickedContainer.data( 'currentVote', clickedVote );

		//console.log( 'chose', clickedVote );
	},
	ajaxVote            : function ( $container ) {

		var $ = jqPla,
			_this = SubitoTexto.contestResults;

		var currentVote = $container.data( 'currentVote' ),
			finalistId = $container.data( 'finalist-id' ),
			contestId = $container.data( 'contest-id' );


		//	console.log( 'About to AJAX', currentVote );

		$.ajax( {
			data    : {
				action     : 'contestResultsVote',
				id         : finalistId,
				contest_id : contestId,
				vote       : currentVote,
				fingerprint: _this.fingerprint
			},
			dataType: 'json',
			type    : 'post',
			url     : CONFIG.vote_contestresults_url
		} ).done( function ( _data ) {

			if ( _data.success == 1 ) {
				// Handle classes
				$container.removeClass( 'confirming' );
				$container.addClass( 'has-voted' );


				$container.find( '.vote-star' ).removeClass( 'active' );
				$container.find( '.vote-star' ).slice( 0, currentVote ).addClass( 'active' );
				$container.find( '.stars-container' )
					.off( 'mouseenter.votefinalist' )
					.off( 'mouseleave.votefinalist' );

				$container.data( 'hasVoted', true );

				_this.combineVotes();

				setTimeout( function () {

					//.off( 'click.votefinalist');

					$container.find( '.inner' ).unwrap();
					$container.find( '.back' ).remove();
				}, 500 );


				Cookies.set( 'contest-results-' + contestId, _this.allVotes, { expires: 365 } );
			}

		} );

	},
	equalHeights        : function () {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;

		var maxHeight = 0;
		_this.$finalistsInfo.css( {
			height: 'auto'
		} );

		if ( window.innerWidth >= _this.finalistBreakpoint ) {

			for ( var i = 0; i < _this.$finalistsInfo.length; i++ ) {
				var $finalist = _this.$finalistsInfo.eq( i ),
					finalistHeight = $finalist.outerHeight();

				maxHeight = finalistHeight > maxHeight ? finalistHeight : maxHeight;
			}

			_this.$finalistsInfo.css( {
				height: maxHeight
			} );

		}
	},
	displayConfirmation : function ( $clicked, iVote ) {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;

		var $inner = $clicked.find( '.inner' ),
			$stars = $clicked.find( '.stars-container' );

		_this.$activeConfirmation = $inner.wrap( '<div class="perspective-container" />' );
		_this.$activeConfirmationBack = $( _this.confirmationTemplate( $stars ) ).insertAfter( $inner );


		setTimeout( function () {
			$clicked.addClass( 'confirming' );
		}, 10 );


		// Make sure the confirmation stars aren't 'votable'
		_this.$activeConfirmationBack
			.on( 'click', '.vote-star', function ( e ) {
				e.preventDefault();
			} )
			.on( 'click', '.buttons-container button', function ( e ) {
				e.preventDefault();

				var $this = $( this ),
					isYes = $this.hasClass( 'vote-confirm-yes' );


				if ( isYes ) {
					// confirmer
					_this.ajaxVote( $this.parents( '.finalist' ) );
				} else {
					// Annuler
					$clicked.removeClass( 'confirming' );
					//console.log( $clicked, $inner );

					setTimeout( function () {
						$inner.unwrap();

						$clicked.find( '.back' ).remove();

						$clicked.find( '.vote-star' ).removeClass( 'active' );

						$clicked.removeData( 'currentVote' );
					}, 500 );
				}

			} );


	},
	confirmationTemplate: function ( $stars ) {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;

		var htmlStars = $stars[ 0 ].outerHTML;

		return '<div class="back"><p class="question">Merci de confirmer ton vote&nbsp;:</p>' +
			htmlStars +
			'<div class="buttons-container clearfix">' +
			'<button class="vote-confirm-yes">Confirmer</button>' +
			'<button class="vote-confirm-no">Annuler</button>' +
			'</div></div>';

	},
	combineVotes        : function () {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;

		_this.allVotes = [];

		_this.$finalists.each( function ( i, el ) {

			var $this = $( this ),
				hasVoted = $this.data( 'hasVoted' ),
				currentVote = $this.data( 'currentVote' ),
				finalistId = $this.data( 'finalist-id' ),
				contestId = $this.data( 'contest-id' );


			if ( hasVoted && currentVote ) {
				_this.allVotes.push( {
					contestId  : contestId,
					finalistId : finalistId,
					currentVote: currentVote
				} );
			}

		} );

	},
	cookieVote          : function () {
		var $ = jqPla,
			_this = SubitoTexto.contestResults;

		var contestId = _this.$finalists.eq( 0 ).data( 'contest-id' ),
			cookieValue = Cookies.get( 'contest-results-' + contestId );


		if ( cookieValue ) {
			cookieValue = JSON.parse( cookieValue );
			//console.log( cookieValue );
			for ( var i = 0; i < cookieValue.length; i++ ) {
				var voteObj = cookieValue[ i ],
					$finalist = _this.$finalists.filter( '[data-finalist-id="' + voteObj.finalistId + '"]' ),
					$allStars = $finalist.find( '.vote-star' ),
					iVote = voteObj.currentVote;

				$allStars.slice( 0, iVote ).addClass( 'active' );
				$finalist.find( '.stars-container' )
					.off( 'mouseenter.votefinalist' )
					.off( 'mouseleave.votefinalist' );

				$finalist
					.data( 'hasVoted', true )
					.data( 'currentVote', iVote )
					.addClass( 'has-voted' );

				//console.log('CookieVote', voteObj, $finalist);

			}
		}
	}
}


